import React, { useEffect } from 'react';
import { Form, Button, Col, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import loginimg from '../../Assets/Images/forget.png';
import logo from '../../Assets/Images/Caduceus 512x512.gif';
import { FORGOT_PASSWORD, USER_BASE_URL } from '../../API';

function ForgetPassword() {
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const navigate = useNavigate();

  useEffect(() => {
    const storedEmail = localStorage.getItem('email');
    if (storedEmail) {
      setValue('email', storedEmail);
    }
  }, [setValue]);

  const submitHandler = async (data) => {
    data.language = 'ENGLISH';
    try {
      const response = await axios.post(`${USER_BASE_URL}${FORGOT_PASSWORD}`, data);
      if (response.status === 200) {
        localStorage.setItem('email', data.email);
        toast.success(response?.data?.data);
        navigate('/email-sent-confrimation');
      }
    } catch (error) {
      const errMessage =
        error.response?.data?.error_message ||
        error.response?.data?.error_description ||
        'Failed to send password reset link.';
      console.error(error);
      toast.error(errMessage);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <section className="login-section">
        <div className="container-fluid g-0">
          <Row className="row-min-h">
            <Col lg={6} className="img-n">
              <div className="upper-fig-main-login">
                <figure className="login-img-main">
                  <img src={loginimg} alt="Forgot Password Illustration" className="img-fluid" />
                </figure>
              </div>
            </Col>
            <Col lg={6}>
              <div className="inner-login-mian">
                <div className="loginupper-right forgot">
                  <figure className="creden_page_logo">
                    <img src={logo} alt="Site Logo" className="img-fluid" />
                  </figure>
                  <h2>Forgot Your Password?</h2>
                  <p className="auth_page_sub_heading">
                    Enter your email and we will send you a link to reset your password.
                  </p>
                  <Form onSubmit={handleSubmit(submitHandler)}>
                    <Row>
                      <Col md={12}>
                        <Form.Group controlId="formGridEmail" className="comn-class-inputs mb-0">
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Enter Your Email"
                            autoFocus
                            {...register('email', {
                              required: 'Email is required.',
                              pattern: {
                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                message: 'Please enter a valid email.',
                              },
                            })}
                          />
                          {errors.email && (
                            <span className="error">{errors.email.message}</span>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Button className="login-btn" type="submit">
                      Send
                    </Button>
                    <div className="auth-bottom-link-sec">
                      <p>
                        Back to <Link to="/login">Login</Link>
                      </p>
                    </div>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
}
export default ForgetPassword;